export type PRChecklistTaskID = number;

export interface PRChecklistTask {
  id: PRChecklistTaskID;
  repository: string;
  task: string;
}
